<template>
  <div class="animated fadeIn">
    <div class="my-5">
      <div class="display-4 font-3xl text-center">
        <span v-if="sampleType"
          >Please select a {{ sampleType.name }} package.</span
        >
        <span v-else
          >To see the available packages, select a package type.</span
        >
      </div>
    </div>
    <div v-if="sampleType">
      <div
        v-for="(group, index) in testPackageGroups.models"
        :key="index"
        class="text-left mt-4"
      >
        <div v-if="group.getTestPackages() && group.getTestPackages().length">
          <div class="display-4 font-2xl mb-3">{{ group.name }}</div>
          <b-list-group>
            <submission-test-package-item
              v-for="(iterPackage, index) in getSortedTestPackagesModels(group)"
              :key="index"
              :testPackage="iterPackage"
              :active="testPackage && iterPackage.id === testPackage.id"
              @selectTestPackage="selectTestPackage"
            ></submission-test-package-item>
          </b-list-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubmissionNav from "@/components/submissions/SubmissionNav";
import SubmissionSampleAnalytes from "../../components/submissions/SubmissionSampleAnalytes";
import SubmissionTestPackageItem from "../../components/submissions/SubmissionTestPackageItem";
import TestPackageGroupCollection from "../../collections/lab/TestPackageGroupCollection";

export default {
  components: {
    SubmissionTestPackageItem,
    SubmissionSampleAnalytes,
    SubmissionNav
  },
  name: "SubmissionAddStep2",
  props: {
    sampleType: {
      type: Object,
      default: () => null
    },
    testPackageGroups: {
      type: Object,
      default: () => new TestPackageGroupCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    isPackageActive(id) {
      return this.testPackage && id && this.testPackage.id === id;
    },
    selectTestPackage(testPackage) {
      this.$emit("selectTestPackage", testPackage);
    },
    getSortedTestPackagesModels (group) {
      return [...group.getTestPackages().models].sort((a, b) => a.name.localeCompare(b.name))
    }
  }
};
</script>
